import app from "app";
import I18N from "app/i18n";

export default function(button_code) {
    app.view_template("_add_page_header.mustache", {
        addButtonText: I18N.t(button_code)
    }, {}, function(result) {
        $('.mainContainer').prepend(result);
    });
}